var _rect, _g, _path, _g2, _path2, _path3, _g3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLdo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_317_7499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C28.832 0 36 7.16797 36 16C36 24.832 28.832 32 20 32C11.168 32 4 24.832 4 16C4 7.16797 11.168 0 20 0Z",
    fill: "white",
    fillOpacity: 0.06,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C28.5559 0.5 35.5 7.44411 35.5 16C35.5 24.5559 28.5559 31.5 20 31.5C11.4441 31.5 4.5 24.5559 4.5 16C4.5 7.44411 11.4441 0.5 20 0.5Z",
    stroke: "white",
    strokeOpacity: 0.06,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_7499",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C28.832 0 36 7.16797 36 16C36 24.832 28.832 32 20 32C11.168 32 4 24.832 4 16C4 7.16797 11.168 0 20 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_7499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0L36 32M36 0L4 32",
    stroke: "black",
    strokeWidth: 0.0128,
    strokeMiterlimit: 22.9256
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_317_7499",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 14,
    width: 18,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H29V29H11V14Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_317_7499)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_317_7499",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 14,
    width: 18,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9883 18.8398L12.8594 14.7695L12.6641 15.0664C10.4766 18.4336 10.9648 22.8359 13.8437 25.6641C17.2344 28.9922 22.7383 28.9922 26.1328 25.6641C29.0117 22.8359 29.4961 18.4336 27.3086 15.0664L27.1172 14.7695L19.9883 18.8398Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_317_7499)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6797 19.7266C28.6797 24.5234 24.7891 28.4141 19.9883 28.4141C15.1875 28.4141 11.2969 24.5234 11.2969 19.7266C11.2969 14.9258 15.1875 11.0352 19.9883 11.0352C24.7891 11.0352 28.6797 14.9258 28.6797 19.7266Z",
    fill: "url(#paint0_linear_317_7499)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9883 9.75391L13.8438 13.2617L19.9883 16.7695L26.1328 13.2617L19.9883 9.75391Z",
    fill: "url(#paint1_radial_317_7499)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.6641L12.8594 14.7695L19.9883 18.8398L27.1055 14.7695L20 10.6641Z",
    fill: "#CACACA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9883 3.83984L13.8438 13.2617L19.9883 16.7695V3.83984Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9883 16.7695L26.1328 13.2617L19.9883 3.83984V16.7695Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_317_7499",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_317_7499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_317_7499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_7499",
    x1: 20.0652,
    y1: 38.4448,
    x2: 19.7269,
    y2: 15.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_317_7499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9872 13.2608) scale(0.3072)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdo);
export default __webpack_public_path__ + "static/media/LDO.0e5bef2e1e2859f3d8629270dac70b2e.svg";
export { ForwardRef as ReactComponent };